/*
 * @Description:
 * @Date: 2021-09-26 15:02:05
 */
import http from '@/utils/http/axios';
import { MenuList, ResourceList, EntpRnv } from './types';

enum Api {
  logout = '/logOut', // 退出
  resourceList = '/api/v1/userSignIn/user/resourceList', // 当前用户页面权限
  menuList = '/api/v1/userSignIn/user/menuList', // 菜单列表
  entpRnv = '/api/v1/entp/entpRnv' // 查询企业认证状态
}

export const logout = async () =>
  http.request(
    {
      url: Api.logout,
      method: 'POST'
    },
    { yapi: 1287 }
  );
export const resourceList: ResourceList = async params =>
  http.request(
    {
      url: Api.resourceList,
      method: 'POST',
      params
    },
    { yapi: 1287 }
  );
// 菜单去 http://yapi.jimijiayuan.cn/project/1287/interface/api/30920 配置
export const menuList: MenuList = async () =>
  http.request(
    {
      url: Api.menuList,
      method: 'POST'
    },
    { yapi: 1287 }
  );
export const entpRnv: EntpRnv = async () =>
  http.request(
    {
      url: Api.entpRnv,
      method: 'POST'
    },
    { yapi: 1287 }
  );
